import { TableFieldModel } from '@/model/TableList'

export const TableField: TableFieldModel[] = [
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'no',
    fieldName: '编号'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'express',
    fieldName: '快递公司'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'sendFlag',
    fieldName: '发货/收货'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'type',
    fieldName: '物品类型'
  }, {
    componentType: 'el-rate',
    componentName: '输入框',
    fieldKey: 'automation',
    fieldName: 'API自动化',
    convert: context => {
      const { rowData } = context
      const { automation } = rowData
      return automation ? '是' : '否'
    }
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'canAutomation',
    width: 100,
    fieldName: '自动下单',
    convert: context => {
      const { rowData } = context
      const { canAutomation } = rowData
      return canAutomation ? '是' : '否'
    }
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'expressNo',
    fieldName: '快递单号'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'goods',
    fieldName: '物品名称'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'contact',
    fieldName: '联系人'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'phone',
    fieldName: '电话号码'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'place',
    fieldName: '省市县'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'placeDetail',
    fieldName: '详细地址'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'mark',
    fieldName: '备注'
  }
]
